import getBanners from "../api/banners/getBanners";
import addBanner from "../api/banners/addBanner";
import editBanner from "../api/banners/editBanner";
import deleteBanner from "../api/banners/deleteBanner";

const BannerStore = {
    namespaced: true,
    state: {
        banners: [],
    },
    getters: {
        banners ({ banners, }) {
            return banners;
        },
    },
    mutations: {
        setBanners (state, banners) {
            state.banners = banners;
        },
        addBanner (state, banner) {
            state.banners.push(banner);
        },
        editBanner (state, updatedBanner) {
            state.banners
                .splice(
                    state.banners
                        .findIndex(
                            ({ _id }) => _id === updatedBanner._id
                        ),
                    1,
                    updatedBanner
                )
            state.banners
                .sort(
                    (a, b) => a.order - b.order
                );
        },
        deleteBanner (state, bannerId) {
            state.banners
                .splice(
                    state.banners
                        .findIndex(
                            ({ _id }) => _id === bannerId
                        ),
                    1
                );
        },
    },
    actions: {
        async load (
            { commit }
        ) {
            let banners;
            try {
                banners = await getBanners();
            } catch (e) {
                console.error(e);
                return;
            }
            commit("setBanners", banners);
            return banners;
        },
        async add (
            { commit },
            newBanner,
        ) {
            let banner;
            try {
                banner = await addBanner(newBanner);
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("addBanner", banner);
            return banner;
        },
        async edit (
            { commit },
            { _id, ...rest }
        ) {
            let banner;
            try {
                banner = await editBanner(
                    _id,
                    rest
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("editBanner", banner);
            return banner;
        },
        async delete (
            { commit },
            bannerId
        ) {
            try {
                await deleteBanner(bannerId);
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit("deleteBanner", bannerId);
        },
    },
};

export default BannerStore;
